module.exports = __webpack_public_path__ + "/login_ui/img/mt-efdd09cdc15966170f9e267dd603e601.svg";